import http from '@/services/http'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    saveInProgress: false,
    investor: getEmptyInvestor(),
  },
  mutations: {
    CLEAR(state) {
      state.investor = getEmptyInvestor()
    },
    START_FETCH(state) {
      state.fetchInProgress = true
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
    },
    SET_INVESTOR_PROFILE_DATA(state, investor) {
      state.investor = investor
    },
    SET_INVESTOR_PROFILE_FIELDS(state, data) {
      Object.assign(state.investor, data)
    },
    SET_INVESTOR_PROFILE_FIELD(state, { field, value }) {
      state.investor[field] = value
    },
    SET_INVESTMENT_VALUES(state, { min, max }) {
      state.investor.investment_min = min
      state.investor.investment_max = max
    },
    START_SAVE(state) {
      state.saveInProgress = true
    },
    STOP_SAVE(state) {
      state.saveInProgress = false
    },
    ADD_NEW_MEMBER(state) {
      state.investor.members.push({
        first_name: '',
        last_name: '',
        title: '',
        email: '',
        linkedint: '',
      })
    },
  },
  actions: {
    async fetch({ commit }, { id }) {
      return await fetch({ commit }, { id })
    },
    async refetch({ commit, state }) {
      const id = state.investor.id
      return await fetch({ commit }, { id })
    },
    async updateFields({ commit, state }, data) {
      return await updateFields({ commit, state }, data)
    },
    async updateField({ commit, state }, { field, value }) {
      return await updateFields({ commit, state }, { [field]: value })
    },
  },
}

async function fetch({ commit }, { id }) {
  commit('START_FETCH')
  try {
    const url = `/investors/${id}`
    const response = await http.getAuthed(url)
    commit('SET_INVESTOR_PROFILE_DATA', response.data)
  } finally {
    commit('STOP_FETCH')
  }
}

async function updateFields({ commit, state }, data) {
  console.log(' => updateFields', data)
  commit('START_SAVE')
  try {
    commit('SET_INVESTOR_PROFILE_FIELDS', data)
    const url = `/investors/${state.investor.id}/update`
    await http.postAuthed(url, data)
  } finally {
    commit('STOP_SAVE')
  }
}

function getEmptyInvestor() {
  return {
    id: null,
    name: '',
    bg_img_url: '',
    logo_url: '',
    website: '',
    city: null,
    country: null,
    type: null,
    business_types: [],
    stages: [],
    sectors: [],
    product_types: [],
    people: [],
    regions: [],
    round_stages: [],
    investment_min: null,
    investment_max: null,
    investment_policy: '',
    members: [],
  }
}
